/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthenticationResponse
 */
export interface AuthenticationResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    accessToken: string;
    /**
     * 
     * @type {Date}
     * @memberof AuthenticationResponse
     */
    accessTokenExpiresAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AuthenticationResponse
     */
    mfaRequired: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AuthenticationResponse
     */
    mfaExpiresAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AuthenticationResponse
     */
    qrCodeUri?: string;
}

export function AuthenticationResponseFromJSON(json: any): AuthenticationResponse {
    return AuthenticationResponseFromJSONTyped(json, false);
}

export function AuthenticationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'accessTokenExpiresAt': (new Date(json['accessTokenExpiresAt'])),
        'mfaRequired': json['mfaRequired'],
        'mfaExpiresAt': !exists(json, 'mfaExpiresAt') ? undefined : (new Date(json['mfaExpiresAt'])),
        'qrCodeUri': !exists(json, 'qrCodeUri') ? undefined : json['qrCodeUri'],
    };
}

export function AuthenticationResponseToJSON(value?: AuthenticationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessToken': value.accessToken,
        'accessTokenExpiresAt': (value.accessTokenExpiresAt.toISOString()),
        'mfaRequired': value.mfaRequired,
        'mfaExpiresAt': value.mfaExpiresAt === undefined ? undefined : (value.mfaExpiresAt.toISOString()),
        'qrCodeUri': value.qrCodeUri,
    };
}

